import { Typography } from "@mui/material";

const Note = () => {
  return (
    <>
      <Typography my={1} mt={4} variant="body2" color={"red"}>
        ⓘ Payment will be collected by your driver upon delivery via payment link sent to your mobile
      </Typography>
      <Typography my={1} mt={4} variant="body2" color={"red"}>
        For jobs of £500 or more a 50% deposit must be paid before the job starts
      </Typography>
      <Typography my={1} mt={4} variant="body2" color={"red"}>
        We accept all major credit and debit cards and payment types such as Apple Pay, Google Pay, Klarna and Link
      </Typography>
    </>
  );
};

export default Note;
